import React from 'react';
import usaFlag from '../assets/flags/usa-flag.png';
import canadaFlag from '../assets/flags/canada-flag.png';
import australiaFlag from '../assets/flags/australia.png';
import bosniaf from '../assets/flags/bosnia-and-herzegovina.png';
import ukf from '../assets/flags/united-kingdom.png';
import georgiaf from '../assets/flags/georgia.png';
import belarusf from '../assets/flags/flag.png';
import russiaf from '../assets/flags/russia.png';
import irelandf from '../assets/flags/ireland.png';
import italyf from '../assets/flags/italy.png';
import germanyf from '../assets/flags/germany.png';
import japanf from '../assets/flags/japan.png'
import koreaf from '../assets/flags/korea.png'
import kazakhf from '../assets/flags/kazakh.png'
import kyrgf from '../assets/flags/kyrg.png'
import indiaf from '../assets/flags/india.png'
import armeniaf from '../assets/flags/armenia.png'

function PartnerLogosSlider() {
  return (
    <div className="partner-logos">
      <div className="partner-slider">
        <img src={usaFlag} alt="KU" />
        <img src={canadaFlag} alt="Monash University" />
        <img src={australiaFlag} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={ukf} alt="KU" />
        <img src={bosniaf} alt="Monash University" />
        <img src={georgiaf} alt="UNSW" />

        <img src={belarusf} alt="KU" />
        <img src={russiaf} alt="Monash University" />
        <img src={irelandf} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={italyf} alt="KU" />
        <img src={germanyf} alt="Monash University" />

        <img src={japanf} alt="KU" />
        <img src={koreaf} alt="Monash University" />
        <img src={kazakhf} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={kyrgf} alt="KU" />
        <img src={indiaf} alt="Monash University" />
        <img src={armeniaf} alt="Monash University" />
        <img src={usaFlag} alt="KU" />
        <img src={canadaFlag} alt="Monash University" />
        <img src={australiaFlag} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={ukf} alt="KU" />
        <img src={bosniaf} alt="Monash University" />
        <img src={georgiaf} alt="UNSW" />

        <img src={belarusf} alt="KU" />
        <img src={russiaf} alt="Monash University" />
        <img src={irelandf} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={italyf} alt="KU" />
        <img src={germanyf} alt="Monash University" />

        <img src={japanf} alt="KU" />
        <img src={koreaf} alt="Monash University" />
        <img src={kazakhf} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={kyrgf} alt="KU" />
        <img src={indiaf} alt="Monash University" />
        <img src={armeniaf} alt="Monash University" />

        {/*repeat*/}
        <img src={usaFlag} alt="KU" />
        <img src={canadaFlag} alt="Monash University" />
        <img src={australiaFlag} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={ukf} alt="KU" />
        <img src={bosniaf} alt="Monash University" />
        <img src={georgiaf} alt="UNSW" />

        <img src={belarusf} alt="KU" />
        <img src={russiaf} alt="Monash University" />
        <img src={irelandf} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={italyf} alt="KU" />
        <img src={germanyf} alt="Monash University" />

        <img src={japanf} alt="KU" />
        <img src={koreaf} alt="Monash University" />
        <img src={kazakhf} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={kyrgf} alt="KU" />
        <img src={indiaf} alt="Monash University" />
        <img src={armeniaf} alt="Monash University" />
        <img src={usaFlag} alt="KU" />
        <img src={canadaFlag} alt="Monash University" />
        <img src={australiaFlag} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={ukf} alt="KU" />
        <img src={bosniaf} alt="Monash University" />
        <img src={georgiaf} alt="UNSW" />

        <img src={belarusf} alt="KU" />
        <img src={russiaf} alt="Monash University" />
        <img src={irelandf} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={italyf} alt="KU" />
        <img src={germanyf} alt="Monash University" />

        <img src={japanf} alt="KU" />
        <img src={koreaf} alt="Monash University" />
        <img src={kazakhf} alt="UNSW" />
        {/* Repeat logos to simulate endless slider */}
        <img src={kyrgf} alt="KU" />
        <img src={indiaf} alt="Monash University" />
        <img src={armeniaf} alt="Monash University" />
        
      </div>
    </div>
  );
}

export default PartnerLogosSlider;